import {CountUp} from "countup.js";

export const drainAnimation = () => {
   /**
    * Класс представляющий DrainAnimation
    * @class
    */
   class DrainAnimation {
      animate() {
         this.items.forEach((item, index) => setTimeout(() => {
            item.el.style.opacity = "";
            item.bar.style.height = "";
            if (!item.percentInstance.error.error) item.percentInstance.start();
         }, (this.delay * 1000) * index));
         this.isPlayed = true;
      }
      constructor(el, duration = 0.8, delay = 0.5) {
         el._app_ ??= {};
         el._app_.drainAnimation = this;

         this.el = el;
         this.duration = duration;
         this.delay = delay;
         el.style.height = el.offsetHeight + "px";
         this.items = [];
         [...el.children].forEach(item => {
            const obj = {};
            obj.el = item;
            obj.el.style.opacity = "0";
            obj.el.style.transitionDuration = duration + "s";
            obj.bar = item.querySelector(".drain-item__bottom");
            obj.bar.style.height = "0";
            obj.bar.style.transitionDuration = duration + "s";


            obj.percent = item.querySelector(".drain-item__percentage");
            obj.targetPercent = +(obj.percent.textContent.slice(0, -1));
            obj.percentInstance = new CountUp(obj.percent, obj.targetPercent, {suffix: "%", duration: this.duration});


            this.items.push(obj);
         });
         el.addEventListener("click", () => el.classList.add("--active"));
      }
   }

   const drainItemsBlocks = document.querySelectorAll(".drain__items");
   drainItemsBlocks.forEach(drainItemsBlock => new DrainAnimation(drainItemsBlock));
};